import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Grid } from "@mui/material";
import { postsStore } from "../../stores/posts/postsStore";
import { pageStyle } from "../../assets/styles/styles";
import { IfPageHasPostsPaginator, PostsPaginator } from "../../components/entities/posts/post/PostsPaginator";
import { GalleryList } from "../../components/entities/posts/Photos/GalleryList";
import { GalleryLayout } from "../../components/entities/posts/Photos/GalleryLayout";
import Typography from "@mui/material/Typography";
import { textColor } from "../../assets/styles/colors";
import { ClickToSeeMore, useCategoryResponsiveName } from "../../components/entities/posts/Photos/GalleryCarousel";
import { useEffect } from "react";
import { useParams } from "react-router";
import { wwwLinks } from "../../variables/wwwRoutes";
import { categoriesStore } from "../../stores/useCategoriesStore";
import { RamiStrip } from "../../components/logo/RamiStrip";
import { WwwAppbarWithoutPlaceholderOnDesktop } from "../../components/navbars/appbar/WwwAppbar";
import { WeUseCookies } from "../../components/popups/WeUseCookies";
import { HeaderLogo } from "../../components/logo/HeaderLogo";
import { WwwFooter } from "../../components/footers/WwwFooter";
import { ImageFullViewPopup } from "../../components/popups/ImageFullView";
import { ProductFullViewPopup } from "../../components/popups/ProductFullView";
import { useOnLazyPageLoad } from "../../hooks/useOnAppLoad";
const paginatorSX = { paddingTop: 1, paddingBottom: 1 };
const CategoryHeader = ({ category }) => {
    const name = useCategoryResponsiveName(category);
    return (_jsx(Grid, { item: true, xs: 12, children: _jsxs(Typography, { sx: { fontSize: '1.5rem', padding: 2, paddingBottom: 1, paddingTop: 3, color: textColor, cursor: 'pointer', textAlign: 'center' }, onClick: () => { categoriesStore.setCategoryFilters([]); wwwLinks.gallery(); }, color: "text.secondary", gutterBottom: true, children: [name, " ", _jsx(ClickToSeeMore, { children: "\u2190 view in gallery" }, void 0)] }, void 0) }, void 0));
};
export const GallerySingleCategory = () => {
    postsStore.useFilterData();
    const categories = categoriesStore.useCategoryFilters();
    return (_jsxs(Grid, { container: true, spacing: 2, sx: pageStyle, children: [_jsxs(GalleryLayout, { children: [categories.map(i => _jsx(CategoryHeader, { category: i }, i.id)), _jsx(Grid, { item: true, children: _jsx(Box, { sx: paginatorSX, children: _jsx(PostsPaginator, {}, void 0) }, void 0) }, void 0), _jsx(Grid, { item: true, children: _jsx(GalleryList, {}, void 0) }, void 0), _jsx(Box, { sx: paginatorSX, children: _jsx(IfPageHasPostsPaginator, {}, void 0) }, void 0)] }, void 0), _jsx(ImageFullViewPopup, {}, void 0), _jsx(ProductFullViewPopup, {}, void 0)] }, void 0));
};
export const WwwGalleryCategoryPage = () => {
    useOnLazyPageLoad();
    const { categoryId } = useParams();
    const category = categoriesStore.useCategory(categoryId);
    useEffect(() => {
        if (category)
            categoriesStore.setCategoryFilters([category]);
        else
            wwwLinks.gallery();
    }, [category]);
    if (!category)
        return _jsx(_Fragment, {}, void 0);
    return (_jsxs(_Fragment, { children: [_jsx(WwwAppbarWithoutPlaceholderOnDesktop, {}, void 0), _jsx(Grid, { container: true, justifyContent: 'center', sx: { width: '100%', padding: 2 }, children: _jsx(Grid, { item: true, children: _jsx(RamiStrip, {}, void 0) }, void 0) }, void 0), _jsx(GallerySingleCategory, {}, void 0), _jsx(HeaderLogo, {}, void 0), _jsx(WwwFooter, {}, void 0), _jsx(WeUseCookies, {}, void 0)] }, void 0));
};
//# sourceMappingURL=WwwGalleryCategoryPage.js.map